import { StyledLink as BaseLink } from 'baseui/link';

type ILinkProps = any;
export const Link = (props: ILinkProps) => {
  return <BaseLink {...props} />;
};
